import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { type EdgeId, isPathLookupEdgeData } from '@ipfabric/utils';
import { getShowPathLookupDetailArgs } from 'components/DeviceView/helpers/getShowPathLookupDetailArgs';
import { showPathLookupEdgeDetail } from 'components/DeviceView/model/commands/showPathLookupEdgeDetail';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { changePathInspectorActiveNodeOnShowEdgeDetail } from './changePathInspectorActiveNodeOnShowEdgeDetail';

export interface ShowPacketDetailCommand {
  packetEdgeId: EdgeId;
}

export const showPacketDetail: GraphCommandFactory<ShowPacketDetailCommand> =
  (cmdContext, dispatch) => (command) => {
    const { graph } = cmdContext.getState();
    const edgeData = graph.edges[command.packetEdgeId];
    if (!isPathLookupEdgeData(edgeData)) {
      stumble('Cannot show packet detail for non-pathlookup edge');
      return;
    }
    cmdContext
      .getDeviceView()
      .dispatch(
        showPathLookupEdgeDetail,
        getShowPathLookupDetailArgs(edgeData, graph),
      );
    dispatch(changePathInspectorActiveNodeOnShowEdgeDetail);
  };
